import ConditionFieldMixins from './mixins.js';
import Options from 'trunks/vue/share/components/options.js';

const ConditionRadioButton = {
  mixins: [ConditionFieldMixins],

  components: {
    'Options': Options
  },

  data: function() {
    return {
      selectedOptions: _.chain(this.judgements.inclusion?.in || [])
        .map((option_id) => {
          if (option_id === 0 && this.field.hasOtherOption) {
            return this.field.otherOption;
          } else {
            return _.find(this.field.options, (option) => option.id === option_id);
          }
        })
        .compact()
        .value()
    };
  },

  template: `
    <div class="form-field-value">
      <Options :initialSelectedOptions='selectedOptions'
               :options='field.options'
               :otherOption='field.otherOption'
               :multiple=true
               customIcon='slp-circle-o'
               @valueChange='valueChange' />
    </div>
  `,

  watch: {
    selectedOptions: function() {
      this.$emit('judgementsChanged', this.getJudgements());
    }
  },

  methods: {
    valueChange: function(options) {
      this.selectedOptions = options;
    },

    getJudgements: function() {
      return {
        inclusion: {
          in: _.pluck(this.selectedOptions, 'id'),
          mode: 'any'
        }
      };
    }
  }
};

export default ConditionRadioButton;
